<h2 mat-dialog-title>
  <mat-icon color="warn">warning</mat-icon>
  Potential Duplicates Detected
</h2>

<div mat-dialog-content class="duplicate-content" *ngIf="data as dialogData">
  <div class="dup-toolbar">
    <p class="dup-summary">{{ dialogData.summary }}</p>
    <button mat-stroked-button color="primary" (click)="copySummary()">
      <mat-icon>content_copy</mat-icon>
      <span *ngIf="!copySuccess">Copy Summary</span>
      <span *ngIf="copySuccess">Copied</span>
    </button>
  </div>

  <p class="copy-feedback" *ngIf="copySuccess">Summary copied to clipboard.</p>
  <p class="copy-feedback error" *ngIf="copyError">Unable to copy summary. Try again.</p>

  <div class="dup-list">
    <div class="dup-item" *ngFor="let d of dialogData.duplicates"
         [class.high]="d.severity === 'high'"
         [class.medium]="d.severity === 'medium'"
         [class.low]="d.severity === 'low'">
      <div class="dup-row">
        <span class="dup-type">{{ d.type }}:</span>
        <span class="dup-val">{{ d.value }}</span>
        <span class="dup-badge"
              [class.high]="d.severity === 'high'"
              [class.medium]="d.severity === 'medium'"
              [class.low]="d.severity === 'low'">{{ d.severity }}</span>
      </div>
      <div class="dup-reason">{{ d.reason }}</div>
      <div class="dup-location">Existing in {{ d.existingLocation }}</div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="duplicate-actions">
  <button mat-button (click)="cancel()">Review Again</button>
  <span class="spacer"></span>
  <button mat-flat-button color="warn" (click)="proceed()">Submit Anyway</button>
</div>
